import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  usuario: {
    nome: string;
    email: string;
    telefone: string;
    cpf: string;
    cnpj: string;
    status: string;
    comissao_certificado: string;
    comissao_pai: string;
    created_at: string;
  };
  endereco: {
    cep: string;
    logradouro: string;
    bairro: string;
    numero: string;
    uf: string;
    cidade: string;
    complemento: string;
  };
  permissoes: string[];
}

// tipagem do que o hook retorna
type IReponse = IResponseData;

async function getPerfil(): Promise<IReponse> {
  const response = await backend.get<IResponseData>('/perfil');
  return response.data;
}

export function usePerfil() {
  return useQuery(['perfil'], () => getPerfil(), {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
  });
}
